/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * Configuration Service API
 * Documentation of the controllers and endpoints used in the configuration-service.
 * OpenAPI spec version: deploy-only-master-2221
 */
import type {
  GetStoreInfoByStoreIdParams,
  GetStoreInfoByStoreIdServerParams,
  MainWebShop,
  StoreInfoDTO,
} from '@as-react/common-types/configuration-service';
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryFetch } from '../../utils/orval/queryFetch';
import { queryKeyMutator } from '../../utils/orval/queryKeyMutator';
import { useQueryFetch } from '../../utils/orval/useQueryFetch';
import type { ErrorType } from '../../utils/orval/useQueryFetch';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get the basic store information
 */
export const useGetStoreInfoByStoreIdHook = () => {
  const getStoreInfoByStoreId = useQueryFetch<StoreInfoDTO>();

  return useCallback(
    (
      mainWebshop: string,
      storeId: number,
      params: GetStoreInfoByStoreIdParams,
      operationName = 'getStoreInfoByStoreId',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getStoreInfoByStoreId(
        { url: `/api/store/info/${mainWebshop}/${storeId}`, method: 'GET', params, signal },
        { operationName: 'getStoreInfoByStoreId', ...options }
      );
    },
    [getStoreInfoByStoreId]
  );
};

export const useGetStoreInfoByStoreIdQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>,
  TError = ErrorType<StoreInfoDTO>,
>(
  mainWebshop: string,
  storeId: number,
  params: GetStoreInfoByStoreIdParams,
  operationName = 'getStoreInfoByStoreId',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { mainWebshop, storeId, params, operationName },
    { url: `/api/store/info/${mainWebshop}/${storeId}`, queryOptions }
  );

  const getStoreInfoByStoreId = useGetStoreInfoByStoreIdHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>> = ({ signal }) =>
    getStoreInfoByStoreId(mainWebshop, storeId, params, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(mainWebshop && storeId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStoreInfoByStoreIdQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>
>;
export type GetStoreInfoByStoreIdQueryError = ErrorType<StoreInfoDTO>;

export function useGetStoreInfoByStoreId<
  TData = Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>,
  TError = ErrorType<StoreInfoDTO>,
>(
  mainWebshop: string,
  storeId: number,
  params: GetStoreInfoByStoreIdParams,
  operationName: undefined | string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStoreInfoByStoreId<
  TData = Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>,
  TError = ErrorType<StoreInfoDTO>,
>(
  mainWebshop: string,
  storeId: number,
  params: GetStoreInfoByStoreIdParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStoreInfoByStoreId<
  TData = Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>,
  TError = ErrorType<StoreInfoDTO>,
>(
  mainWebshop: string,
  storeId: number,
  params: GetStoreInfoByStoreIdParams,
  operationName?: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the basic store information
 */

export function useGetStoreInfoByStoreId<
  TData = Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>,
  TError = ErrorType<StoreInfoDTO>,
>(
  mainWebshop: string,
  storeId: number,
  params: GetStoreInfoByStoreIdParams,
  operationName = 'getStoreInfoByStoreId',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetStoreInfoByStoreIdHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetStoreInfoByStoreIdQueryOptions(mainWebshop, storeId, params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the basic store information
 */
export const getStoreInfoByStoreIdServer = (
  mainWebshop: string,
  storeId: number,
  params: GetStoreInfoByStoreIdServerParams,
  operationName = 'getStoreInfoByStoreId',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<StoreInfoDTO>(
    { url: `/public/store/info/${mainWebshop}/${storeId}`, method: 'GET', params, signal },
    { operationName: 'getStoreInfoByStoreId', ...options }
  );
};

export const useGetStoreInfoByStoreIdServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>,
  TError = ErrorType<StoreInfoDTO>,
>(
  mainWebshop: string,
  storeId: number,
  params: GetStoreInfoByStoreIdServerParams,
  operationName = 'getStoreInfoByStoreId',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { mainWebshop, storeId, params, operationName },
    { url: `/public/store/info/${mainWebshop}/${storeId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>> = ({ signal }) =>
    getStoreInfoByStoreIdServer(mainWebshop, storeId, params, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(mainWebshop && storeId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStoreInfoByStoreIdServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>
>;
export type GetStoreInfoByStoreIdServerQueryError = ErrorType<StoreInfoDTO>;

export function useGetStoreInfoByStoreIdServer<
  TData = Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>,
  TError = ErrorType<StoreInfoDTO>,
>(
  mainWebshop: string,
  storeId: number,
  params: GetStoreInfoByStoreIdServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>,
          TError,
          Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStoreInfoByStoreIdServer<
  TData = Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>,
  TError = ErrorType<StoreInfoDTO>,
>(
  mainWebshop: string,
  storeId: number,
  params: GetStoreInfoByStoreIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>,
          TError,
          Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetStoreInfoByStoreIdServer<
  TData = Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>,
  TError = ErrorType<StoreInfoDTO>,
>(
  mainWebshop: string,
  storeId: number,
  params: GetStoreInfoByStoreIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the basic store information
 */

export function useGetStoreInfoByStoreIdServer<
  TData = Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>,
  TError = ErrorType<StoreInfoDTO>,
>(
  mainWebshop: string,
  storeId: number,
  params: GetStoreInfoByStoreIdServerParams,
  operationName = 'getStoreInfoByStoreId',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInfoByStoreIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetStoreInfoByStoreIdServerQueryOptions(mainWebshop, storeId, params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMainWebShopConfigServer = (
  name: string,
  operationName = 'getMainWebShopConfig',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<MainWebShop>(
    { url: `/mainwebshop/name/${name}`, method: 'GET', signal },
    { operationName: 'getMainWebShopConfig', ...options }
  );
};

export const useGetMainWebShopConfigServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getMainWebShopConfigServer>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  operationName = 'getMainWebShopConfig',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMainWebShopConfigServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ name, operationName }, { url: `/mainwebshop/name/${name}`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMainWebShopConfigServer>>> = ({ signal }) =>
    getMainWebShopConfigServer(name, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!name, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMainWebShopConfigServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMainWebShopConfigServerQueryResult = NonNullable<Awaited<ReturnType<typeof getMainWebShopConfigServer>>>;
export type GetMainWebShopConfigServerQueryError = ErrorType<unknown>;

export function useGetMainWebShopConfigServer<
  TData = Awaited<ReturnType<typeof getMainWebShopConfigServer>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMainWebShopConfigServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMainWebShopConfigServer>>,
          TError,
          Awaited<ReturnType<typeof getMainWebShopConfigServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMainWebShopConfigServer<
  TData = Awaited<ReturnType<typeof getMainWebShopConfigServer>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMainWebShopConfigServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMainWebShopConfigServer>>,
          TError,
          Awaited<ReturnType<typeof getMainWebShopConfigServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMainWebShopConfigServer<
  TData = Awaited<ReturnType<typeof getMainWebShopConfigServer>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMainWebShopConfigServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetMainWebShopConfigServer<
  TData = Awaited<ReturnType<typeof getMainWebShopConfigServer>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  operationName = 'getMainWebShopConfig',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMainWebShopConfigServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetMainWebShopConfigServerQueryOptions(name, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
